import { render, staticRenderFns } from "./BOQWOQTYTable.vue?vue&type=template&id=5be61c35&"
import script from "./BOQWOQTYTable.vue?vue&type=script&lang=js&"
export * from "./BOQWOQTYTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports